<template>
  <div class="c-app">
    <app-filter placeholder="请输入游戏应用名称或ID" @on-change="filterData" @on-search="searchFilterData" />

    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <app-table
          ref="appTable"
          :loading="loading"
          :height="tableHeight"
          :data="tableList"
          :columns="tableCols"
          @on-del="deleteRowApp"
          @on-refresh="getData"
        />
        <Page
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page pager"
          size="small"
        />
      </Viewport>
    </div>
  </div>
</template>

<script>
import mixin from '../mixins/mixin'
import AppFilter from './components/app-filter'
import AppTable from './components/app-table.vue'
import columns from '../data/app_manage_column'
import { isArray, timeout } from '@/common/js/utils'
import { setLocal } from '@/common/js/api'
import { listApp, delApp } from '@/api/manage.model'

export default {
  name: 'app',
  mixins: [mixin],
  components: { AppFilter, AppTable },
  computed: {
    tableCols() {
      return this.columns.filter((ret) => !ret.show)
    }
  },
  methods: {
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      listApp(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    deleteRowApp({ id }) {
      this.loading = true
      delApp({ id }).then((data) => {
        this.loading = false
        if (data) {
          this.$Message.success('游戏应用删除成功！')
          timeout(600).then(() => {
            this.getData()
          })
        }
      })
    },
    setLocalPage(size) {
      setLocal('APP_MANAGE_PAGESIZE', size)
    }
  },
  data() {
    return {
      tableHeight: 330,
      loading: null,
      columns: columns
    }
  }
}
</script>

<style lang="scss" scoped>
.c-app {
  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }

  .c-control-btn {
    padding: 0 8px;
    background-color: #fff;

    .c-btn {
      width: 132px;
      flex: 0 0 128px;
    }
  }
}
</style>
